import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Archived from './views/Archived.vue'
import firebase from 'firebase/app'
// eslint-disable-next-line
import auth from 'firebase/auth'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/archived',
      name: 'archived',
      component: Archived,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/boards/:id',
      name: 'BoardView',
      meta: {
        requiresAuth: true
      },
      component: () =>
        import( /* webpackChunkName: "BoardView" */ './views/BoardView.vue')
    },
    {
      path: '/login',
      name: 'LoginView',
      meta: {
        requiresAuth: false
      },
      component: () =>
        import( /* webpackChunkName: "LoginView" */ './views/LoginView.vue')
    },
    {
      path: '/signup',
      name: 'SignupView',
      meta: {
        requiresAuth: false
      },
      component: () =>
        import( /* webpackChunkName: "SignupView" */ './views/SignupView.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(rec => rec.meta.requiresAuth)) {
    let user = firebase.auth().currentUser
    if (user) {
      next()
    } else {
      next({
        name: 'LoginView'
      })
    }
  } else {
    next()
  }
})

export default router
